export default __webpack_public_path__ + "static/media/IMG_8293.509db117.jpg";